module.exports = __webpack_public_path__ + "images/urbee_small2c7c59736b5e054bb8dc84d98038afa2.png";